import QualificationsCreate from './QualificationsCreate';
import QualificationsEdit from './QualificationsEdit';

export default {
    create: QualificationsCreate,
    edit: QualificationsEdit,
};
